import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=0bcf2689&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=0bcf2689&prod&lang=scss&scoped=true"
import style1 from "./feedback.vue?vue&type=style&index=1&id=0bcf2689&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf2689",
  null
  
)

export default component.exports